<template>
  <div>
    <div class="modal-tnc modal fade in" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content popup-tnc-bbb">
          <div class="modal-body">
            <div class="modal-body">
              <h2 class="tnc-title">Syarat dan Ketentuan:</h2>
              <ul class="tnc-list">
                <li class="tnc-item">
                  <span class="bullet">1</span>
                  <p>Beli produk COSRX apa pun <b>min. Rp250.000</b> di event K‑Beauty Street Festival Sociolla.</p>
                </li>

                <li class="tnc-item">
                  <span class="bullet">2</span>
                  <p>Tunjukkan <b>bukti struk pembelian</b> kepada Beauty Advisor COSRX di booth COSRX.</p>
                </li>

                <li class="tnc-item">
                  <span class="bullet">3</span>
                  <p><b>Scan QR Code</b> pada vending machine dari SOCO App.</p>
                </li>

                <li class="tnc-item">
                  <span class="bullet">4</span>
                  <p>Capai skor tertentu & <b>dapatkan freebies</b> dari COSRX (selama stok tersedia).</p>
                </li>

                <li class="tnc-item">
                  <span class="bullet">5</span>
                  <p>Syarat & Ketentuan dapat berubah sewaktu‑waktu tanpa pemberitahuan.</p>
                </li>
              </ul>
            </div>
          </div>
          <div style="display: flex; width: 100%; justify-content: center; padding-bottom: 60px">
            <button class="button-tutup" @click.prevent="$emit('close')">Tutup</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade in"></div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
};
</script>

<style lang="scss" scoped>
.tnc-title {
  font-family: 'Pretendard';
  font-weight: 700;
  font-size: 48px;
  line-height: 1.2;
  color: #000;
  text-align: center;
  margin: 0 0 65px;
}

.tnc-list {
  display: grid;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 22px;
}

.tnc-item {
  display: flex;
  align-items: flex-start;
  font-family: 'Pretendard';
  font-weight: 400;
  gap: 24px;
  margin-bottom: 22px;
  font-size: 30px;
  line-height: 40px;
  letter-spacing: 0px;
}

.bullet {
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #fff;
  border: 4px solid #000;
  color: #000;
  font-family: 'Pretendard';
  font-size: 24px;
  line-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.tnc-item p {
  margin: 0;
  color: #000;
  font-family: 'Pretendard';
  font-size: 28px;
  line-height: 32px;
}

.tnc-item p b {
  font-family: 'Pretendard';
  font-weight: 700;
}

.modal-tnc {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  padding: 60px 45px;
  width: 90vw;
}
.modal-tnc > * {
  width: 100%;
  margin: 0;
}
.popup-tnc-bbb {
  background-color: #fef57b;
  border-radius: 20px;
  width: 880px;
  .button-tutup {
    background: #6cebfb;
    border-radius: 48px;
    padding: 30px 120px;
    margin: 0 auto;
    color: black;
    font-family: 'Pretendard';
    font-size: 32px;
    font-weight: 700;
    line-height: 38.4px;
    text-align: center;
    width: 410px;
    height: 98px;
  }
  .modal-header,
  .modal-footer {
    border: 0;
  }
  .modal-body {
    position: relative;
    width: 100%;
    padding: 30px;
    .close {
      opacity: 1;
      position: absolute;
      top: -50px;
      right: -45px;
      z-index: 151;
    }
    img {
      object-fit: cover;
      width: 100%;
    }
  }
}
@media screen and (max-width: 950px) and (min-width: 900px) {
  .popup-tnc-bbb {
    width: 750px;
  }
  .modal-tnc {
    padding: 0px 45px;
    width: 90vw;
    height: fit-content;
  }
}
</style>
